<template>
    <div class="installt">
        <div class="intext">运费模版</div>
        <div class="addpoper" @click="openDialog">
            <div> <el-icon :size="24" color="#fff">
                    <Plus style=" margin-right: 8px" />
                </el-icon></div>
            <div style="height: 24px;">添加模版</div>
        </div>
    </div>
    <div class="viplist">
        <div class="quanbu">
            全部
        </div>

        <div class="vipt">
            <div class="screen">
                <el-cascader v-model="value" :options="options" placeholder="类型筛选:" @change="handleChange" />
            </div>
            <div class="search">
                <div style="width: 24px;height: 24px;margin-right: 14px;text-align: center;">
                    <el-icon size="24">
                        <Search />
                    </el-icon>
                </div>
                <div>
                    <input type="text" placeholder="关键字搜索" v-model="wordKey" @keyup.enter="wordkey">
                </div>
            </div>
            <!-- <div class="calendar">
                <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                    start-placeholder="Start date" end-placeholder="End date" @change="changedata" format="MM.DD" />
            </div> -->

        </div>
        <div class="vipporpe" v-loading="loading">
            <table>
                <thead>
                    <tr>
                        <th style="width: 300px;">模版名称</th>
                        <th>计价方法</th>
                        <th>起步量</th>
                        <th>起步价</th>
                        <th>增加</th>
                        <th>加价</th>
                        <th>创建时间</th>
                        <th class="states">操作</th>

                    </tr>
                </thead>
                <tbody>
                    <tr @click="gomessage(item.uid, item.identity)" v-for="(item, index) in infolist" :key="index">
                        <td v-html="item.templateName">

                        </td>
                        <td>
                            {{ item.chargingId == 1 ? '按重量' : '按件数' }}
                        </td>
                        <td>
                            {{ item.first + '(件/KG)' }}
                        </td>
                        <td>
                            {{ item.firstMoney }}
                        </td>
                        <td>
                            {{ item.renew + '(件/KG)' }}
                        </td>
                        <td>
                            {{ item.renewMoney }}
                        </td>
                        <td style="width: 150px;">
                            {{ datahuan(item.creattime) }}
                        </td>
                        <td>
                            <div class="operate">
                                <div class="operates">
                                    <div style="cursor: pointer;" @click="bianji(item.id)">编辑</div>
                                    <div style="cursor: pointer;" @click="deltem(item.id, item.isShow)"
                                        :style="{ 'color': item.isShow == 1 ? 'red' : '#1787FF' }">{{ item.isShow ==
            1 ? '停用' : '启用' }}</div>
                                </div>
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>


           
        </div>

        <div style=" height: 70px;"></div>
        <div class="example-pagination-block">
                <el-pagination :disabled="loading" background v-model:current-page="pageCount"  :page-size="pageSize"
                    layout="prev, pager, next" :pager-count="6" :total="total" @current-change="changepige" />
            </div>

        <div class="pagechoose">

            显示结果：

            <div class="pagees">

                <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

            </div>

        </div>
        <Noshu :disabled="loading" :lengths="infolist.length"></Noshu>

    </div>

</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus'
import Noshu from '@/components/Noshu.vue'

import api from '@/api/api'
const screenType = ref(0)
let value = ref(null)
let wordKey = ref('')
let pageCount = ref(1)
let total = ref(1)
let loading = ref(false)

const options = reactive([
    {
        value: '0',
        label: '全部',
    },

    {
        value: '2',
        label: '模板名称',
    }
])
const handleChange = (value) => {
    console.log(value)
    screenType.value = value[0]
}

let pageSize = ref(6)

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    infoList()
}

const infoList = async () => {
    loading.value = true
    try {
        let data
        if (wordKey.value.length < 1) {
            data = {
                pageCount: pageCount.value,
                pageSize: pageSize.value,
            }
        } else {
            data = {
                pageCount: pageCount.value,
                pageSize: pageSize.value,
                screenType: screenType.value,
                wordKey: wordKey.value,
            }
        }
        const res = await api.freightTemplates(data)

        if (res.data) {
            infolist.value = res.data.tlist
            console.log(infolist.value)
            total.value = res.data.total
            loading.value = false
        } else {
            loading.value = false

            infolist.value = []
        }
    } catch (error) {
        console.log(error)
    }
}
onMounted(() => {
    pageCount.value = 1
    infoList()
})
const wordkey = () => {
    infoList()
}
const deltem = (id, isShow) => {
    let show = (isShow == 1 ? '停用' : '启用')

    ElMessageBox.confirm('确定' + show + '改模板？')
        .then(() => {
            freightTemplatedel(id, isShow)
        })
        .catch(() => {
            // catch error
            // 
        })
}
const freightTemplatedel = async (id, isShowe) => {
    let isShow = (isShowe == 1 ? false : true)

    let data = {
        isShow: isShow,
        templateId: id
    }
    const res = await api.freightTemplatedel(data)
    if (res.success) {
        ElMessage({
            message: '删除成功',
            type: 'success',
            onClose: () => {
                infoList()
            }
        })
    } else {
        ElMessage.error('删除失败！' + res.message)
    }
}
const router = useRouter()
const infolist = ref([])
let startTime = ref('')
let endTime = ref('')
let nowdata = new Date()
let mextdata = new Date()

const choosedata = ref([nowdata, mextdata])
const changedata = (e) => {
    startTime.value = datahuan(e[0])
    endTime.value = datahuan(e[1])
    console.log(startTime.value)
    console.log(endTime.value)
    infoList()
}
const datahuan = (days) => {
    if (days) {
        const date = new Date(days)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${year}-${month}-${day}`
    } else {
        return ''
    }

}

const gomessage = (userId, identity) => {
    // router.push({
    //     path: '/home/viplist/vipmeessage',
    //     query: {
    //         userId: userId,
    //         identity: identity
    //     }
    // })

}

//上一页
const prev = () => {
    pageCount.value--
    infoList()
}
//下一页
const nextpige = () => {

    pageCount.value++
    infoList()
}
//跳转页面
const changepige = (val) => {

    pageCount.value = val
    infoList()

}
const bianji = (id) => {
    router.push(
        {
            path: "/home/shingcharge/addCharge",
            query: {
                templateId: id
            }
        }
    )
}
const openDialog = () => {
    router.push('/home/shingcharge/addCharge')
}
</script>

<style lang="scss" scoped>
::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #F8F8F8;
    --el-input-border-color: transparent;


    input {
        font-size: 16px;
        color: #718096;
    }

}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #F8F8F8 !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

}

::v-deep .el-pagination {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}



.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {
        width: 132px;
        height: 48px;
        background: rgba(63, 140, 255);
        box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
}


.viplist {
    position: relative;
    margin-top: 25px;
    height: calc(100% - 85px);


    .pagechoose {
        position: absolute;
        bottom: 10px;
        left: 0px;
        width: 200px;
        height: 70px;
        padding-left: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .pagees {
            width: 71px;
            height: 40px;
            border: 1px solid #EEEFF2;
            border-radius: 8px;
            padding: 8px 0 0 0px;
            box-sizing: border-box;

            input {
                width: 80%;


            }
        }
    }

    min-width: 1166px;
    // min-height: 662px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;

    .quanbu {
        height: 60px;
        line-height: 60px;
        padding-left: 36px;
        box-sizing: border-box;
        border-bottom: 1px solid #D9D9D9;

    }

    .vipporpe {
        width: 100%;
        padding-left: 15px;
        box-sizing: border-box;


        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;

            thead {
                height: 46px;
                text-align: left;
                line-height: 46px;
                font-size: 14px;
                font-weight: 400;
                color: #4D585F;
                border-bottom: 1px solid #EEEFF2;

                .states {
                    text-align: center;
                }
            }

            tbody {
                tr {
                    height: 71px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #000000;
                    border-bottom: 1px solid #EEEFF2;

                    td:last-child {
                        width: 66px;
                        padding-right: 9px;

                        .operate {

                            color: #1787FF;
                            font-weight: 400;
                            font-size: 12px;
                            margin: 0 auto;
                            padding: 3px;

                            text-align: center;

                            div {

                                height: 15px;
                                line-height: 15px;
                                margin-bottom: 6px;
                            }

                            .operates {
                                display: flex;
                                justify-content: space-between;

                            }

                        }
                    }

                    td {

                        vertical-align: middle;

                        .statea {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .state {
                                width: 66px;
                                height: 36px;
                                background: #EBF3FF;
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #1787FF;
                            }
                        }


                    }


                }
            }

        }
    }

    .vipt {
        padding-top: 17px;
        margin-left: 15px;
        display: flex;

        .screen {
            width: 168px;
            height: 48px;
            background: #F8F8F8;
            border-radius: 8px;
            margin-right: 24px;
        }

        .search {
            width: 412px;
            height: 48px;
            margin-right: 24px;
            background: #F8F8F8;
            box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            padding-left: 20px;
            box-sizing: border-box;

            input {
                width: 300px;
                border: none;
                outline: none;
                font-size: 16px;
                background: #F8F8F8;

            }

        }

        .calendar {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;



        }

    }
}
</style>